import "./SearchResultTable.css";
import { UserData, UserSearchResult } from "../interfaces/UserInterfaces";
import Checkbox from '@mui/material/Checkbox';
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TablePagination from "@mui/material/TablePagination";
import { AdminContext } from "../contexts/AdminContext";

export interface SearchTableProps {
  numResults: number,
  searchResults: Array<UserSearchResult>,
  navigatePage: (newCountOffset: [number, number]) => void,
  countOffset: [number, number]
}

function SearchResultTable(props: SearchTableProps) {
  const {adminCredentials, getToken} = useContext(AdminContext);
  const [perPage, setPerPage] = useState<number>(props.countOffset[0]);
  const [page, setPage] = useState<number>(Math.floor(props.countOffset[1]/perPage));
  const [pageChange, setPageChange] = useState(false);
  let navigate = useNavigate();

  useEffect(() => {
    setPageChange(false);
  }, [props.searchResults]);

  const handlePerPageChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageChange(true);
    props.navigatePage([parseInt(e.target.value, 10), 0]);

    setPage(0);
    setPerPage(parseInt(e.target.value, 10));
  };

  const DisplayedResultsTable = (props: any) => {
    const results = props.results.map((item: UserSearchResult) => (
      <TableRow
        key={item.id}
        onClick={() =>
          navigate({
            pathname: "/edit-user",
            search: `user=${item.id}&country=${item.country}`,
          })
        }
        hover
        sx={{cursor: 'pointer'}}
      >
        <TableCell key="fn">{item.firstName}</TableCell>
        <TableCell key="ln">{item.lastName}</TableCell>
        <TableCell key="email">{item.email}</TableCell>
        <TableCell key="id">{item.id}</TableCell>
        <TableCell key="country">{item.country}</TableCell>
        <TableCell key="organizations">{(item.organizations as string[]).join(", ")}</TableCell>
        {adminCredentials.isSuperAdmin && (
          <TableCell key="federated">{item.isFederated ? "true" : "false"}</TableCell>
        )}
        <TableCell key="active">
          <Checkbox disabled checked={item.isActive} />
        </TableCell>
      </TableRow>
    ));
    return <>{results}</>;
  };

  const changePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageChange(true);
    setPage(newPage);

    props.navigatePage([perPage, perPage * newPage]);
  };

  return (
    <div>
      {props.searchResults !== undefined && props.searchResults.length > 0 ? (
        <div>
          <div>
            {!pageChange ? (
              <>
                <h1 className="centre-align">Results</h1>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TablePagination
                        count={props.numResults}
                        page={page}
                        onPageChange={changePage}
                        rowsPerPage={perPage}
                        onRowsPerPageChange={handlePerPageChange}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        
                        showLastButton
                      />
                    </TableRow>
                    <TableRow sx={{borderTop: 0}}>
                      <TableCell> Firstname </TableCell>
                      <TableCell> Lastname </TableCell>
                      <TableCell> Email </TableCell>
                      <TableCell> GUID </TableCell>
                      <TableCell> Country </TableCell>
                      <TableCell> Organizations </TableCell>
                      {adminCredentials.isSuperAdmin && (
                        <TableCell> Federated </TableCell>
                      )}
                      <TableCell> Active </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="alternative-rows">
                    {props.searchResults !== undefined ? (
                      <DisplayedResultsTable results={props.searchResults} />
                    ) : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </>  
            ) : (
              <h4>Loading...</h4>
            )}
          </div>
        </div>
      ) : (
        <h3>No Results</h3>
      )}
    </div>
  );
}

export { SearchResultTable };
